<template>
  <v-row justify="center">
    <v-dialog v-model="initialvalue.dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('mybook.deleteConfirm')}}</v-card-title>
        <v-card-text>
          {{$t('mybook.deleteConfirmMSG')}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="initialvalue.dialog=false">
            {{$t('public.close')}}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="loadingDelete"
            @click="ConfirmationDelete"
            data-cy="deleteConfirm"
          >
            {{$t('public.continue')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      initialvalue: this.value,
      loadingDelete: false,
    };
  },
   props: {
    value: {
      type: Object,
      required: true,
    },
  },


  // props: ["deleteBook", "deleteItem"],
  computed: {},
  methods: {
    ConfirmationDelete() {
      this.$store
        .dispatch("DeleteToAPI", `/mybook/${this.initialvalue.deleteItem.bookid}` )
        .then(() => {
          this.$store.dispatch("PushSuccessMsg", this.$t('public.deleteDone'));
          this.loadingDelete = false;
          this.$emit("DialogClose", true);
        })
        .catch((error) => {
          // console.log(error  , 'error')
          this.loadingDelete = false;
          this.$store.dispatch("PushErrorMsg", error.data.message);
        });
    },
  },
};
</script>

